module.exports = __webpack_public_path__ + "fontawesome-webfont.eot?674f50d287a8c48dc19ba404d20fe713";